import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Box, CardMedia } from "@mui/material";

import { } from "../../../../store/slices/question";
import { useSelector } from "../../../../store";
import { quizData } from "../../../../constants";

export default function WebInstructions({
    onChangeWebStyleLayout = () => {}
}) {
	const location = useLocation();
	const navigate = useNavigate();
	const learner = useSelector((state) => state.learner || {});
	const [isDisabled, setIsDisabled] = React.useState(true);
	const [btnCd, setBtnCd] = React.useState(25);
	const publicUrl = process.env.PUBLIC_URL;
	const videoSrc = quizData[learner?.details?.testLevel || 'acsf3shortcourse'].src;

	const videoRef = React.useRef();

	let timer = setTimeout(function () {
		if (btnCd - 1 === 0) {
			setIsDisabled(false);
		}
		setBtnCd(btnCd - 1);
	}, 1000);

    React.useEffect(() => {
        // change the layout
        onChangeWebStyleLayout({
            style: {
                backgroundColor: "#148e8e",
                borderBottom: "60px solid #016d7c",
                hideFooter: true,
            }
        });
    }, [onChangeWebStyleLayout]);

	React.useEffect(() => {
		if (btnCd === 0 && typeof timer !== "undefined") {
			clearTimeout(timer);
		}
	}, [btnCd, timer]);
	const handleConfirmDeclaration = async () => {
		// await dispatch(getNextQuestion([]));

		navigate(`${publicUrl}/question${location?.search || ""}`);
	};
	return (
		<React.Fragment>
			<Box
				sx={{
                    width: "860px",
                    // for small screen desktop
                    "@media (max-width: 1024px), (max-height: 768px)": {
                        width: "800px",
                    },

                    // for tablet
                    "@media (max-width: 800px), (max-height: 600px)": {
                        width: "850px",
                    },
				}}
			>
                <CardMedia
                    component="video" autoPlay
					controls
					controlsList="nodownload noplaybackrate"
					ref={videoRef}
                    sx={{
						marginBottom: "1rem",
						borderRadius: "1rem",
						boxShadow: "1px 1px 1px 2px #383535",
                        objectFit: "contain",
					}}
                    src={videoSrc}
                />
			</Box>
            <Box sx={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                textAlign: "center",
            }}>
                <button
                    style={{
                        cursor: "pointer",
                        display: "inline-block",
                        width: "180px",
                        height: "45px",
                        backgroundColor: !isDisabled ? "#0e9595" : "grey",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        borderBottom: !isDisabled ? "2px solid #0e9595" : "2px solid grey",
                        textDecoration: "none",
                        boxSizing: "border-box",
                        paddingTop: "3px",
                        textAlign: "center",
                        "&:hover": {
                            backgroundColor: "none",
                            cursor: "pointer",
                        },
                    }}
                    onClick={() => handleConfirmDeclaration()}
                    disabled={isDisabled}
                >
                    <Box sx={{
                        fontWeight: "bold",
                        fontSize: "2em",
                        color: "white",
                        textAlign: "center",
                    }}>{`Start ` + (btnCd > 0 ? `${btnCd}s` : "")}</Box>
                </button>
            </Box>
		</React.Fragment>
	);
}